import { Tooltip } from '@sgme/ui';
import type { PropsWithChildren } from 'react';

import type { FixingOrderError, StopLossOrderError } from '@/store/bulkOrder/state.ts';
import type { Way } from '@/types/common.ts';

type WayCellProps = {
  field: string;
  errors: (StopLossOrderError | FixingOrderError)[] | undefined;
  align?: 'center' | 'left' | 'right';
  width?: string | number;
  way: Way | undefined;
};

export const WayCell = (props: PropsWithChildren<WayCellProps>) => {
  const { field, errors, align, width, way, children } = props;

  const fieldError = errors?.find((error) => error.field === field);

  return (
    <td
      align={align}
      width={width}
      className={fieldError !== undefined ? 'p-0' : undefined}
      style={{ backgroundColor: way !== 'Ask' ? '#FCE4EC' : '#E0F7FA', color: way !== 'Ask' ? '#D81B60' : '#00796B' }}
      data-e2e={`${field}-cell`}
    >
      {fieldError !== undefined ? (
        <Tooltip color="danger" contents={<span>{fieldError.message}</span>}>
          <div className="border-bottom border-lg border-danger p-1 text-danger">{children}</div>
        </Tooltip>
      ) : (
        children
      )}
    </td>
  );
};
